'use client'

import { Box, BoxProps } from '@mui/material'
import { ReactElement } from 'react'
import { tss } from 'tss-react/mui'

export type SlateProps = BoxProps & {
    rounded?: true | 'left' | 'right'
}

const useStyles = tss.create(({ theme }) => ({
    root: {
        backgroundColor: theme.palette.grey[200],
        borderRadius: theme.shape.borderRadius * 2,
    },
    roundedLeft: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    },
    roundedRight: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
}))

function Slate({ rounded = true, className, ...props }: SlateProps): ReactElement {
    const { classes, cx } = useStyles()

    return (
        <Box
            className={cx(
                classes.root,
                rounded === 'left' && classes.roundedLeft,
                rounded === 'right' && classes.roundedRight,
                className
            )}
            {...props}
        />
    )
}

export default Slate
